<template>
  <section class="n-section-primary tw-mt-10">
    <div
      v-if="vars.titleText"
      class="tw-flex tw-h-[25vh] tw-w-screen tw-items-center tw-justify-center tw-text-center"
      :style="`background-color: var(--c-${vars.backgroundColor})`"
    >
      <h3 :style="`color: ${vars.textColor};`">{{ vars.titleText }}</h3>
    </div>
    <div v-if="vars.feeTableHtml" class="fee-table tw-self-center tw-overflow-hidden" v-html="vars.feeTableHtml"></div>
  </section>
</template>
<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'FeeTable',

  mixins: [ComponentMixin],
});
</script>
<style scoped>
/* Genel stil */

.fee-table::v-deep(h1),
.fee-table::v-deep(h2),
.fee-table::v-deep(h3),
.fee-table::v-deep(h4),
.fee-table::v-deep(h5),
.fee-table::v-deep(h6) {
  font-weight: bold;
  margin: 1em 0 !important;
  color: #000;
}

.fee-table::v-deep(h2) {
  font-size: 1.5rem; /* Mobil uyumu için */
}

.fee-table::v-deep(p) {
  font-size: 1rem;
  margin: 1em 0;
  line-height: 1.6;
}

.fee-table::v-deep(.inner) {
  width: 95%;
  max-width: 390px;
  margin: 0 auto;
}

@media screen and (min-width: 768px) {
  .fee-table::v-deep(.inner) {
    max-width: 1280px;
  }
}

.fee-table::v-deep(a) {
  padding: unset !important;
}

.fee-table::v-deep(a:hover) {
  color: var(--c-secondary);
}

.fee-table::v-deep(table) {
  width: 100% !important;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 0.85rem;
  border-spacing: 0px;
  overflow-x: auto;
  display: block;
}

.fee-table::v-deep(th),
.fee-table::v-deep(td) {
  border: 1px solid var(--c-primary);
  padding: 8px;
  text-align: left;
}

.fee-table::v-deep(th) {
  background-color: var(--c-primary);
  font-weight: bold;
  color: #333;
}

.fee-table::v-deep(tr:nth-child(even)) {
  background-color: var(--c-section_primary);
}

.fee-table::v-deep(table tr td) {
  word-break: normal;
  border-width: 1px;
  border-style: solid;
  border-color: var(--c-border);
  border-image: initial;
  padding: 5px;
}

.fee-table::v-deep(ul),
.fee-table::v-deep(ol) {
  margin: 0 0 15px 20px;
}

.fee-table::v-deep(li) {
  margin-bottom: 5px;
}
</style>
